import { useQuery } from '@tanstack/react-query';
import { DEFAULT_POLL_RATE_IN_MILLISECONDS } from 'constants/polling';
import { parseJWT } from 'sync/jwt-service/jwt-service';
import { getUser } from 'sync/user-service';
import { ReactQueryKeys } from 'utils/react-query';

type UseUser = {
  userId?: string | null;
  enablePolling?: boolean;
  enabled?: boolean;
  refetchOnMount?: boolean | 'always';
};

export const useUser = (options: UseUser = {}) => {
  const { userId = null, enablePolling = false, enabled = true, refetchOnMount } = options;
  // JWT must alway be present when performing authenticated requests,
  // however we remove JWT during logout in V2 so we need to keep enabled
  // logic till we make V3 hosts app
  const id = userId || parseJWT()?.sub;
  const query = useQuery(ReactQueryKeys.USER({ userId: id! }), () => getUser({ userId: id! }), {
    enabled: enabled && !!id,
    refetchInterval: enablePolling && DEFAULT_POLL_RATE_IN_MILLISECONDS,
    // Cache user for as long as possible, unit it's invalidated manually or via refetchInterval
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnMount,
  });

  return {
    user: query.data || null,
    query,
  };
};
